import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import {
    APPROVAL_WORKFLOW_STATUS,
    type OBJECTS,
    type REVIEW_STATUS,
    type WORKFLOW_STATUS,
} from '@app/shared/constants/shared.constant';
import type { ItemAction } from '@app/shared/interface/common.interface';
import {
    type WorkflowResponsibilityFormGroup,
    WorkflowResponsibilityModel,
} from '@app/shared/models/workflow-responsibility.model';

export type WorkflowFormGroup = ReturnType<typeof Workflow.getForm>;

export class Workflow {
    id?: number;
    status: WORKFLOW_STATUS | REVIEW_STATUS;
    newStatus: WORKFLOW_STATUS | REVIEW_STATUS;
    responsibilityId?: number;
    createdBy: string;
    actions: ItemAction;

    constructor(paramsObject: Partial<Workflow>) {
        Object.assign(this, paramsObject);
    }

    static getForm(obj: Workflow) {
        return new FormGroup({
            id: new FormControl(obj?.id),
            responsibilityId: new FormControl<number>(obj?.responsibilityId, Validators.required),
            newStatus: new FormControl(obj?.newStatus),
            comment: new FormControl(''),
        });
    }
}

export interface ApprovalWorkflowAdapter {
    // Auditable:
    readonly createdBy?: null | string;
    readonly createdDate?: string;
    readonly lastModifiedBy?: null | string;
    readonly lastModifiedDate?: string;

    id: number;
    name: string;
    description: string;
    responsibilities?: WorkflowResponsibilityModel[];
    objectTypes?: { objectType: OBJECTS; id?: number }[];
    status?: APPROVAL_WORKFLOW_STATUS; // here todo remove optional operator later (added now for backward compatibility)
    actions?: ItemAction;
}

export type ApprovalWorkflowFormGroup = ReturnType<typeof getApprovalWorkflowForm>;

export function getApprovalWorkflowForm(data: ApprovalWorkflowAdapter) {
    return new FormGroup({
        id: new FormControl(data?.id || null),
        name: new FormControl(data?.name || 'New Approval Workflow', Validators.required),
        description: new FormControl(data?.description),
        objectTypes: new FormControl((data?.objectTypes || []).map(x => x.objectType)),
        responsibilities: new FormArray<WorkflowResponsibilityFormGroup>(
            (data?.responsibilities || []).map(item =>
                WorkflowResponsibilityModel.getResponsibilityForm(item),
            ),
        ),
        status: new FormControl(
            data?.status || APPROVAL_WORKFLOW_STATUS.ACTIVE,
            Validators.required,
        ),
    });
}
